/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { QRCodeSVG } from 'qrcode.react';
import { PaymentPayee, useCyberStore } from '@entities/tsp';
import { currencySymbols } from '@shared/config';
import { CrossIcon, MultitransferIcon, NspkIcon, SslIcon } from '@shared/assets/icons';
import { Divider, Link, Text } from '@shared/ui/atoms';
import { withTheme } from '@shared/lib/theme';
import { Modal } from '@shared/ui/organisms';
import { paymentSteps } from '../../config/paymentSteps';
interface QrModalProps {
  payee: PaymentPayee;
  open: boolean;
  handleClose: () => void;
  qrLink: string;
  description: string;
}
const SbpQrModalDesktop: FC<QrModalProps> = ({
  payee,
  open,
  handleClose,
  qrLink,
  description
}) => {
  const {
    isPromocodeActivated
  } = useCyberStore();
  const {
    amountInfo
  } = useCyberStore();
  const isSteam = payee.features?.tsp_url === 'steam';
  return <Modal open={open} onClose={handleClose}>
      <ModalWrapper>
        <ContentWrapper>
          <HeaderWrapper>
            <TextWrapper>
              <Text family="MTSCompact" size="h6" weight="medium" color="primary">
                {isPromocodeActivated && isSteam ? amountInfo?.base : amountInfo?.total || 400} {currencySymbols.RUB}
              </Text>
              <Text family="MTSCompact" size="pM" weight="medium" color="secondary">
                {description}
              </Text>
            </TextWrapper>
            <IconButtonWrapper type="button" onClick={handleClose}>
              <CrossIcon />
            </IconButtonWrapper>
          </HeaderWrapper>
          <PaySectionWrapper>
            <QRSectionWrapper>
              <QRCodeWrapper>
                <QRCodeSVG value={qrLink} title="QR Code" size={250} bgColor="#ffffff" fgColor="#000000" level="M" marginSize={4} imageSettings={{
                src: 'https://www.mtsbank.ru/icons/payment/sbp.svg',
                x: undefined,
                y: undefined,
                height: 38,
                width: 38,
                opacity: 1,
                excavate: true
              }} />
              </QRCodeWrapper>
              <StepsList>
                {paymentSteps.map(({
                step,
                description
              }) => <StepItem key={step}>
                    <StepNumber>
                      <Text family="MTSCompact" size="captionL" weight="bold" color="primary">
                        {step}
                      </Text>
                    </StepNumber>
                    <Text family="MTSCompact" size="pM" weight="medium" color="primary">
                      {description}
                    </Text>
                  </StepItem>)}
              </StepsList>
            </QRSectionWrapper>
            <SslWrapper>
              <SslIcon />
              <Text family="MTSCompact" size="pS" weight="regular" color="secondary">
                Платёж защищён по протоколу SSL
              </Text>
            </SslWrapper>
          </PaySectionWrapper>
          <FooterWrapper>
            <Divider />
            <FooterContentWrapper>
              <Text family="MTSCompact" size="captionL" weight="regular" color="secondary">
                Сервис предоставлен платёжной системой Мультитрансфер
              </Text>
              <IconsWrapper>
                <Nspk>
                  <NspkIcon />
                </Nspk>
                <MultiTransfer>
                  <MultitransferIcon />
                </MultiTransfer>
              </IconsWrapper>
            </FooterContentWrapper>
          </FooterWrapper>
        </ContentWrapper>
      </ModalWrapper>
    </Modal>
  // <StyledModal
  //   open={open}
  //   isClosing={isClosing}
  //   onClose={isMobile ? handleCloseModal : handleClose}
  //   closeIcon={<CloseIcon />}
  //   size="md"
  // >
  //   <EasySwipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
  //     <Modal.Body>
  //       <PriceWrapper>
  //         {isPubg
  //           ? (Number(values.amountInfo?.total) + Number(values.amountInfo?.total) * 0.03).toFixed(2)
  //           : isPromocodeActivated
  //           ? values.amountInfo?.base
  //           : values.amountInfo?.total || 400}{' '}
  //         {currencySymbols.RUB}
  //       </PriceWrapper>
  //       <DescriptionWrapper>{description}</DescriptionWrapper>
  //       <Spacer space={32} spacetablet={32} spacemob={32} />
  //       <WrapperContent>
  //         <QRCodeWrapper>
  //           <QRCodeSVG
  //             value={qrLink}
  //             title="QR Code"
  //             size={250}
  //             bgColor="#ffffff"
  //             fgColor="#000000"
  //             level="L"
  //             marginSize={4}
  //             imageSettings={{
  //               src: 'https://www.mtsbank.ru/icons/payment/sbp.svg',
  //               x: undefined,
  //               y: undefined,
  //               height: 38,
  //               width: 38,
  //               opacity: 1,
  //               excavate: true,
  //             }}
  //             style={{ borderRadius: '20px' }}
  //           />
  //         </QRCodeWrapper>
  //         <StepsList>
  //           {paymentSteps.map(({ step, description }) => (
  //             <StepItem key={step}>
  //               <StepNumber>{step}</StepNumber>
  //               <StepText>{description}</StepText>
  //             </StepItem>
  //           ))}
  //         </StepsList>
  //       </WrapperContent>
  //       <Spacer space={8} spacetablet={8} spacemob={8} />
  //       <Ssl>
  //         <SslIcon />
  //         Платёж защищён по протоколу <span style={{ fontWeight: 500 }}>SSL</span>
  //       </Ssl>
  //       <Spacer space={32} spacetablet={32} spacemob={32} />
  //       <OldDivider style={{ backgroundColor: theme.colors.icon.secondary, opacity: 0.5 }} />
  //       <Spacer space={20} spacetablet={20} spacemob={20} />
  //       <WrapperFooter>
  //         <TextWrapper>Сервис предоставлен платёжной системой Мультитрансфер</TextWrapper>
  //         <IconsWrapper>
  //           <Nspk>
  //             <NspkIcon />
  //           </Nspk>
  //           <MultiTransfer>
  //             <MultitransferIcon />
  //           </MultiTransfer>
  //         </IconsWrapper>
  //       </WrapperFooter>
  //     </Modal.Body>
  //   </EasySwipe>
  // </StyledModal>
;
};
export default SbpQrModalDesktop;
const ModalWrapper = /*#__PURE__*/styled('div')({
  name: "ModalWrapper",
  class: "m10u9dtt",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1he86us",
  propsAsIs: false,
  vars: {
    "c1he86us-0": [_exp()]
  }
}));
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "hgzmytg",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "tx94wxa",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.tertiary;
const IconButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconButtonWrapper",
  class: "ioo0d2a",
  propsAsIs: false,
  vars: {
    "ioo0d2a-0": [_exp2()]
  }
}));
const PaySectionWrapper = /*#__PURE__*/styled('div')({
  name: "PaySectionWrapper",
  class: "p1xfmx69",
  propsAsIs: false
});
const QRSectionWrapper = /*#__PURE__*/styled('div')({
  name: "QRSectionWrapper",
  class: "qqnpsrb",
  propsAsIs: false
});
const QRCodeWrapper = /*#__PURE__*/styled('div')({
  name: "QRCodeWrapper",
  class: "q1jegteb",
  propsAsIs: false
});
const StepsList = /*#__PURE__*/styled('div')({
  name: "StepsList",
  class: "sooo9q6",
  propsAsIs: false
});
const StepItem = /*#__PURE__*/styled('div')({
  name: "StepItem",
  class: "s11q857q",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.accent;
const StepNumber = withTheme(/*#__PURE__*/styled('div')({
  name: "StepNumber",
  class: "s18290tx",
  propsAsIs: false,
  vars: {
    "s18290tx-0": [_exp3()]
  }
}));
const SslWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "SslWrapper",
  class: "s1epdrgp",
  propsAsIs: false
}));
const FooterWrapper = /*#__PURE__*/styled('div')({
  name: "FooterWrapper",
  class: "fswgtcl",
  propsAsIs: false
});
const FooterContentWrapper = /*#__PURE__*/styled('div')({
  name: "FooterContentWrapper",
  class: "f1017uhj",
  propsAsIs: false
});
const IconsWrapper = /*#__PURE__*/styled('div')({
  name: "IconsWrapper",
  class: "i4s1dwj",
  propsAsIs: false
});
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.secondary;
const Nspk = withTheme(/*#__PURE__*/styled('div')({
  name: "Nspk",
  class: "n1ri3hiy",
  propsAsIs: false,
  vars: {
    "n1ri3hiy-0": [_exp4()]
  }
}));
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.secondary;
const MultiTransfer = withTheme(/*#__PURE__*/styled('div')({
  name: "MultiTransfer",
  class: "mvin9k0",
  propsAsIs: false,
  vars: {
    "mvin9k0-0": [_exp5()]
  }
}));

// interface StyledModalProps {
//   isClosing: boolean
//   open: boolean
// }

// const StyledModal = withTheme(styled(Modal)<StyledModalProps & ThemeProps>`
//   div[data-testid='text'] {
//     color: ${({ theme }) => theme.colors.text.secondary} !important;
//     font-family: ${({ theme }) => theme.font.family.MTSCompact};
//     font-size: ${({ theme }) => theme.font.size.xs}px;
//     font-style: normal;
//     font-weight: ${({ theme }) => theme.font.weight.regular};
//     line-height: ${({ theme }) => theme.font.lineHeight.xs}px;
//   }
//   /* > div[data-testid='modal-overlay'] {
//     background: var(--BG-Overlay, rgba(9, 5, 32, 0.5));
//     backdrop-filter: blur(5px);
//   } */
//   font-size: ${({ theme }) => theme.font.size.xs}px;
//   > div[data-testid='modal'] {
//     transition: transform 0.5s ease-in-out;

//     transform: ${({ isClosing }) => (isClosing ? 'translateY(100%)' : 'translateY(0)')};
//     background-color: ${({ theme }) => theme.colors.bg.tertiary} !important;
//     color: ${({ theme }) => theme.colors.text.tertiary};
//     position: fixed;
//     bottom: 0;
//     width: 100%;
//     height: auto;
//     overflow-y: auto;
//     border-radius: 32px 32px 0 0;
//     padding-top: 20px;

//     button[data-testid='modal-button-close'] {
//       top: 32px;
//       right: 32px;
//       z-index: 999;
//     }

//     > div {
//       > div {
//         padding: 0 32px 20px 32px;
//       }
//     }
//   }

//   @media (min-width: 768px) {
//     > div[data-testid='modal'] {
//       overflow: hidden;
//       width: 601px;
//       height: auto;
//       position: relative;
//       border-radius: 32px;
//       transform: none;
//       padding-top: 32px;

//       > div {
//         > div {
//           &::before {
//             display: none;
//           }
//         }
//       }
//     }
//   }
// `)

// const PriceWrapper = withTheme(styled.div<ThemeProps>`
//   color: ${({ theme }) => theme.colors.text.primary};
//   font-family: ${({ theme }) => theme.font.family.MTSWide};
//   font-size: ${({ theme }) => theme.font.size.sm}px;
//   font-weight: ${({ theme }) => theme.font.weight.medium};
//   line-height: ${({ theme }) => theme.font.lineHeight.xs}px;
//   margin-bottom: 2px;
// `)

// const DescriptionWrapper = withTheme(styled.div<ThemeProps>`
//   color: ${({ theme }) => theme.colors.text.secondary};
//   font-family: ${({ theme }) => theme.font.family.MTSCompact};
//   font-size: ${({ theme }) => theme.font.size.xxs}px;
//   font-style: normal;
//   font-weight: ${({ theme }) => theme.font.weight.medium};
//   line-height: ${({ theme }) => theme.font.lineHeight.xxs}px;
// `)

// const QRCodeWrapper = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: space-between;
//   border-radius: 20px;
// `

// const WrapperFooter = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 8px;
// `

// const Ssl = withTheme(styled.div<ThemeProps>`
//   display: flex;
//   align-items: center;
//   gap: 4px;
//   color: ${({ theme }) => theme.colors.text.primary};
//   font-family: ${({ theme }) => theme.font.family.MTSCompact};
//   font-size: ${({ theme }) => theme.font.size.xxs}px;
//   font-style: normal;
//   font-weight: ${({ theme }) => theme.font.weight.regular};
//   line-height: ${({ theme }) => theme.font.lineHeight.xxs}px;
// `)

// const StepsList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 24px;
//   margin: 32px 0;
// `

// const StepItem = styled.div`
//   display: flex;
//   align-items: flex-start;
//   gap: 16px;
// `

// const StepText = withTheme(styled.div<ThemeProps>`
//   align-self: center;
//   color: ${({ theme }) => theme.colors.text.primary};
//   font-family: ${({ theme }) => theme.font.family.MTSCompact};
//   font-size: ${({ theme }) => theme.font.size.xxs}px;
//   line-height: ${({ theme }) => theme.font.lineHeight.xxs}px;
// `)

// const StepNumber = withTheme(styled.div<ThemeProps>`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   min-width: 24px;
//   min-height: 24px;
//   background: ${({ theme }) => theme.colors.state.active};
//   border-radius: 50%;
//   color: ${({ theme }) => theme.colors.text.white};
//   font-family: ${({ theme }) => theme.font.family.MTSWide};
//   font-size: ${({ theme }) => theme.font.size.xxs}px;
//   font-weight: ${({ theme }) => theme.font.weight.medium};
// `)

// const WrapperContent = styled.div`
//   display: flex;
//   gap: 24px;
// `

// const NewCardLink = withTheme(styled(Link)<ThemeProps>`
//   color: ${({ theme }) => theme.colors.text.primaryLink} !important;
//   text-decoration: none !important;
//   transition: color 0.3s ease !important;

//   &:hover {
//     color: ${({ theme }) => theme.colors.state.primaryLinkHover} !important;
//   }
// `)

// const TextWrapper = withTheme(styled.div<ThemeProps>`
//   font-family: ${({ theme }) => theme.font.family.MTSCompact};
//   font-weight: ${({ theme }) => theme.font.weight.regular};
//   font-size: ${({ theme }) => theme.font.size.xxs}px;
//   line-height: ${({ theme }) => theme.font.lineHeight.xxs}px;
//   text-transform: none;
//   color: ${({ theme }) => theme.colors.text.secondary};
// `)

// const IconsWrapper = styled.div`
//   display: flex;
//   gap: 12px;
// `

// const Nspk = withTheme(styled.div<ThemeProps>`
//   display: flex;
//   height: 16px;

//   svg {
//     height: 100%;

//     path {
//       fill: ${({ theme }) => theme.colors.icon.secondary} !important;
//     }
//   }
// `)

// const MultiTransfer = withTheme(styled.div<ThemeProps>`
//   display: flex;
//   height: 16px;

//   svg {
//     height: 100%;

//     path {
//       fill: ${({ theme }) => theme.colors.icon.secondary} !important;
//     }
//   }
// `)

require("./SbpQrModalDesktop.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SbpQrModalDesktop.tsx");